import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ChatOptions } from '../../../core/components/chat/chat.component';

@Component({
  selector: 'tt-order-dialog',
  templateUrl: './order-dialog.component.html',
  styleUrls: ['./order-dialog.component.css']
})
export class OrderDialogComponent implements OnInit {
    orderInternalNo;

    @Output()
    public submit = new EventEmitter<void>();

    public edit?: Edit;

    public chatOptions: ChatOptions<OrderComment> = {
        keynames: {
            commentKeyno: 'registered_by_name',
        },
        fetch: {
            save: {
                method: 1280,
                parameters: () => ({ ...this.edit })
            },
            get: {
                method: 1281,
                parameters: () => ({ order_internal_no: this.edit?.order_internal_no })
            }
        }
    }

    public adding = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.orderInternalNo = this.stateService.getStateParams()['order_internal_no'];
    }

    private async loadEdit() {
        if (!!this.orderInternalNo) {
            this.edit = (await this.datatask.Post(1279, { order_internal_no: this.orderInternalNo }))[0];
        }
    }

    private async init() {
        await this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    order_internal_no: string;
    messagetext: string;
}

interface OrderComment extends Comment {
    registered_by_name: string;
    messagetext: string;
    reg_datetime: string;
    orderby: number;
    mymessage: '0' | '1';
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('orderDialog', {
//        templateUrl: 'views/components/views/orderDialog/orderDialog.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'utilityService', 'translateService', 'modalService', 'orderDialogService', function ($stateParams, utilityService, translateService, modalService, orderDialogService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let orderInternalNo = $stateParams.order_internal_no;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                commentListOrders: [],
//                lockedAdd: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await orderDialogService.getEdit({ order_internal_no: orderInternalNo }))[0];
//            }

//            async function loadDialogues() {
//                if (utilityService.validateParmsValue(vm.model.edit.order_internal_no) !== true) return;

//                return vm.model.commentListOrders = await orderDialogService.listDialogues({ order_internal_no: vm.model.edit.order_internal_no });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON ADD PROCEDURE FUNCTION CALL

//            vm.addChanges = function () {
//                vm.model.lockedAdd = true;

//                orderDialogService.addMessage(vm.model.edit).then(async function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedAdd = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedAdd = false;

//                        await loadEdit();
//                        loadDialogues();
//                    }
//                });
//            }

//            // #endregion BUTTON ADD PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadEdit();
//                loadDialogues();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
